export default subscription => subscription.type === 'company' && subscription.isSubscriptionScreen && subscription.isUserAuthenticated
